// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroScreen_root__2Xv6p","centered":"HeroScreen_centered__3DAwx","subtitle":"HeroScreen_subtitle__17ekf","descriptionHolder":"HeroScreen_descriptionHolder__3tO4Y","description":"HeroScreen_description__2szeh","scrollButtonHolder":"HeroScreen_scrollButtonHolder__NWRk8"};
    if(module.hot) {
      // 1586964018569
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  